import { FamilyTreeActionFn, SetRenderWhiteLabeledAction } from '../types';

export const setRenderWhiteLabeledAction: FamilyTreeActionFn<
  SetRenderWhiteLabeledAction
> = (state, action) => {
  return {
    ...state,
    renderWhiteLabeled: action.renderWhiteLabeled,
  };
};
